import React, { useContext } from "react";
import { Button, Grid, makeStyles, Typography } from "@material-ui/core";
import { useHistory } from "react-router";
import { AuthContext } from "../../Context/Auth";
import { Instance } from "../../Context/axiosContext";
import { PrimaryButton } from "../../Shared/Buttons";
const useStyles = makeStyles({
  restaurant: {
    margin: "20px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
});

const RestaurantInfo = ({ restaurant, idToken }) => {
  const history = useHistory();
  const classes = useStyles();
  const { login } = useContext(AuthContext);

  const handleClick = (id, name) => {
    localStorage.setItem("restId", id);
    login(idToken);
    history.push("/");
  };

  return (
    <Grid container sm={8} className={classes.restaurant}>
      <Grid item>
        <Typography style={{ fontSize: "20px" }}>{restaurant.name}</Typography>
      </Grid>
      <Grid item>
        {/* <Button color='secondary' onClick={} variant='contained' size='small'>Login</Button> */}
        <Button
          color="secondary"
          onClick={() => handleClick(restaurant.id, restaurant.name)}
          variant="contained"
          size="small"
        >
          Login
        </Button>
      </Grid>
    </Grid>
  );
};

export default RestaurantInfo;
